































































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import Provider from '@/interfaces/provider';
import { PopularTitle } from '@/interfaces/titles';
import { SnowplowContext, SnowplowTitleContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { TopTitleType } from '@/stores/title.store';
import { TranslateResult } from 'vue-i18n';
import { FilterName } from '@/stores/filter.store';
import { CollectionType } from '@/enums/collection-type';

const Filter = namespace('filter');
const Language = namespace('language');
const Title = namespace('title');

const routesWithTitleList = [
	CollectionType.NEW,
	CollectionType.POPULAR,
	CollectionType.SEARCH,
	CollectionType.WATCHLIST,
];

@Component({
	name: 'AppDefaultFooter',
	components: {},
	serverCacheKey: props => {
		return [
			// locale
			props.locale,
			// providers
			props
				.providers()
				.map((provider: Provider) => provider.short_name)
				.join('-'),
			// topTitles
			Object.keys(props.topTitles)
				.map(topTitlesKey => {
					return (props.topTitles[topTitlesKey] || [])
						.map((item: PopularTitle) => {
							return item.jw_entity_id;
						})
						.join('-');
				})
				.join('-'),
		].join('_');
	},
})
export default class AppDefaultFooter extends Vue {
	@Prop() locale: string;
	@Prop({ default: () => [] }) providers: Provider[];
	@Prop() topTitles: Record<TopTitleType, PopularTitle[]>;

	@Title.State fetchingLists: Record<CollectionType, boolean>;

	@Filter.Action setFilterValue: (payload: {
		filterName: FilterName;
		filterValue: any;
		collectionType: CollectionType;
		updateRouteState: boolean;
	}) => void;

	@Language.Getter country: string;

	providersLimit = 5;
	moviesLimit = 5;
	showsLimit = 5;

	currentYear = new Date().getFullYear();

	get version() {
		return process.env.VERSION;
	}

	get showAppFooter() {
		const currentCollection: CollectionType = this.$route.meta?.collectionType;
		return !routesWithTitleList.includes(currentCollection) || !this.isFetchingList;
	}

	get isFetchingList() {
		const currentCollection: CollectionType = this.$route.meta?.collectionType;
		return this.fetchingLists[currentCollection];
	}

	get shouldLinkToUpcoming() {
		return this.$router.getRoutes().some(({ name }) => name === 'app.titles.upcoming.list');
	}

	handleTopProvider(provider: Provider, collectionType: CollectionType, index: number) {
		const translatable =
			collectionType === CollectionType.POPULAR
				? 'WEBAPP_FOOTER_TOP_X_PROVIDERS'
				: 'WEBAPP_FOOTER_TOP_X_NEW_ON_PROVIDER';

		this.trackClick(provider, this.$t(translatable, { x: this.providersLimit }), index);
		this.setProvider(provider, collectionType);
	}

	trackClick(item: PopularTitle | Provider, headline: TranslateResult, index: number) {
		const itemType: string = this.getItemType(item);
		const props = {
			action: '' as string,
			label: '' as string,
			additionalContexts: [] as SnowplowContext[],
		};
		switch (itemType) {
			case 'title':
				props.action = 'title_clicked';
				props.label = `${headline}`;
				const { id, object_type } = item as PopularTitle;
				const titleContext = new SnowplowTitleContext(id, object_type);
				props.additionalContexts.push(titleContext);
				break;
			default:
				props.action = 'tabchange';
				props.label = `${headline},${item.id}`;
		}
		const { action, label } = props;
		TrackingHelper.trackEvent(
			'userinteraction',
			{
				action,
				label,
				property: 'footer',
				value: index,
				useLastRoute: true,
			},
			props.additionalContexts
		);
	}

	setProvider(provider: Provider, collectionType: CollectionType) {
		this.setFilterValue({
			filterName: 'providers',
			filterValue: [provider.short_name],
			collectionType,
			// prevents duplicate navigation
			updateRouteState: false,
		});
	}

	private getItemType(item: any): string {
		if (item.title !== undefined) {
			return 'title';
		} else {
			return 'provider';
		}
	}
}
